import React, { FunctionComponent } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanelProps, TabsComponentProps } from './TabsComponent.types';

function TabPanel(props: TabPanelProps): JSX.Element {
  const { tab, currentSelected, index } = props;
  const { tabPanelNode } = tab;
  return (
    <div className={tab.contentClassName} hidden={currentSelected !== index}>
      {tabPanelNode}
    </div>
  );
}

const TabsComponent: FunctionComponent<TabsComponentProps> = props => {
  const {
    className,
    centered,
    onChange,
    orientation,
    scrollButtons = 'off',
    selectionFollowsFocus,
    tabsChildren,
    textColor,
    value,
    variant,
  } = props;
  return (
    <>
      <Tabs
        className={className}
        centered={centered}
        onChange={onChange}
        orientation={orientation}
        scrollButtons={scrollButtons}
        selectionFollowsFocus={selectionFollowsFocus}
        textColor={textColor}
        value={value}
        variant={variant}
      >
        {tabsChildren.map((tab, ix) => (
          <Tab
            key={`${ix}_${tab.label}`}
            className={tab.tabClassName}
            disabled={tab.disabled}
            icon={tab.icon}
            label={tab.label}
            value={tab.tabValue || ix}
            wrapped={tab.wrapped || false}
          />
        ))}
      </Tabs>
      {tabsChildren.map((tab, ix) =>
        tab.tabPanelNode ? (
          <TabPanel
            key={`${ix}_${tab.label}`}
            index={tab.tabValue || ix}
            currentSelected={value}
            tab={tab}
          />
        ) : null
      )}
    </>
  );
};

export { TabsComponent, TabPanel };
